export default {"src":"/_next/static/media/loan.100b62e8.svg","height":33,"width":32};